import styled from 'styled-components';
import ReportSvg from '../../assets/report/report.svg';

const ReportIcon = styled(ReportSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.6rem'};
height: ${props => props.height || '3.6rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default ReportIcon;